import { QueryClient } from "@tanstack/react-query";
import axios from "axios";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry on 404 errors
        if (axios.isAxiosError(error) && error.response?.status === 404) {
          return false;
        }
        // Default retry logic: retry up to 3 times for other errors
        return failureCount < 3;
      },
    },
  },
});
